<template>
  <f7-toolbar tabbar labels bottom>
    <!-- Budgets -->
    <f7-link v-if="isManager" :href="links.root"
             :icon-ios="active === 0 ? 'f7:chart_pie_fill' : 'f7:chart_pie'"
             icon-md="material:pie_chart"
             :text="$t('menu.budgets')"
             tab-link
             :tab-link-active="active === 0"/>
    <!-- My Card -->
    <f7-link v-else :href="links.root" :icon-ios="active === 2 ? 'f7:creditcard_fill' : 'f7:creditcard'"
             icon-md="material:payment" :text="$t('menu.myCard')" tab-link :tab-link-active="active === 2"/>
    <!-- Requests -->
    <f7-link v-if="isManager" :href="links.manageRequests" :icon-ios="active === 1 ? 'f7:square_list_fill' : 'f7:square_list'"
             icon-md="material:list" :text="$t('menu.requests')" tab-link :tab-link-active="active === 1"
             :icon-badge="$store.getters['requests/countPending']" badge-color="pink"/>
    <!-- Requests -->
    <f7-link v-else :href="links.myRequests" :icon-ios="active === 1 ? 'f7:square_list_fill' : 'f7:square_list'"
             icon-md="material:list" :text="$t('menu.requests')" tab-link :tab-link-active="active === 1"/>
    <!-- My Card -->
    <f7-link v-if="isManager" :href="myCard.noOfUnclassifiedTransactions ? links.spend : links.myCard" :icon-ios="active === 2 ? 'f7:creditcard_fill' : 'f7:creditcard'"
             icon-md="material:payment" :text="$t('menu.myCard')" tab-link :tab-link-active="active === 2"
             :icon-badge="myCard.noOfUnclassifiedTransactions" badge-color="pink"/>
    <!-- Spend -->
    <f7-link v-else :href="links.spend" :icon-ios="active === 3 ? 'f7:reload_round_fill' : 'f7:reload_round'"
             icon-md="material:swap_horiz" :text="$t('menu.spend')" tab-link :tab-link-active="active === 3"
             :icon-badge="myCard.noOfUnclassifiedTransactions" badge-color="pink"/>
    <!-- Company -->
    <f7-link v-if="isAdmin" :href="links.company" :icon-ios="active === 3 ? 'f7:person_3_fill' : 'f7:person_3'"
             icon-md="material:group" :text="$t('menu.company')" tab-link :tab-link-active="active === 3"
             :icon-badge="!hasValidBilling ? '!' : ''" badge-color="pink"/>
  </f7-toolbar>
</template>

<script>
  import helpers from '@/utils/helpers'

  export default {
    name: 'main-toolbar',
    mixins: [helpers],
    props: {
      active: Number
    }
  }
</script>

<style lang="scss" scoped>
  .toolbar {
    --f7-toolbar-bg-color: var(--f7-color-blue);
    --f7-tabbar-link-active-color: #FFFFFF;
    --f7-tabbar-link-active-border-color: #FFFFFF;
    --f7-tabbar-link-inactive-color: rgba(255, 255, 255, 0.7);
  }
</style>
